export default "__VITE_ASSET__CxAih2xZ__"